import React from 'react'
import './HomePageEnrolSection.scss'

export default function HomePageEnrolSection(props) {

    function scrollToAbout() {
        let sectionElement = document.getElementsByClassName('homepage-course-wrapper');
        if (sectionElement.length > 0) {
            sectionElement[0].scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }
    }

    return (
        <div className="enrol-wrapper">
            <div className="background-video-wrapper" dangerouslySetInnerHTML={{ __html: '<video class="background-video" id="homepage-enrol-video" width="100%" autobuffer autoplay loop muted playsinline><source src="/assets/videos/landing-page-video.mp4" type="video/mp4" />Your browser does not support the video tag. </video>' }}></div>
            
            <div className="enrol-details">
                <div className="enrol-details-content">
                    <h3 className="enrol-text-company">GMC</h3>
                    <h4 className="enrol-text-program">Employers' Orientation Programme</h4>
                    <p className="enrol-text">Mobile First</p>
                    <p className="enrol-text">Anywhere, Anytime, Any Device</p>
                    <p className="enrol-text">AVAILABLE IN ENGLISH, CHINESE, MALAY AND TAMIL</p>
                </div>
            </div>
            <div className="enrol-wrapper-container MuiContainer-root MuiContainer-maxWidthLg">
                <a className="enrol-btn" href={"/registration/agreement"}>Enrol Now</a>
                {/* <a className="enrol-btn" href={"#"}>Enrol Now</a> */}
                <a className="enrol-btn" href={"/login"} >Log In to EOP</a>
            </div>
        </div>
    );
};